import events from 'events';
import data from './../data/data';
import AppDispatcher from './../dispatcher/AppDispatcher';
import AppConstants from './../constants/AppConstants';

const CHANGE_EVENT = 'change';
let _paused = false;
let _levelStats = {};
let _baskets = [];
let _balls = [];
let _shootingBall = false;
let _basketToRemove;
let _ballToRemove;
let _totalBaskets = 0;
let _totalShots = 0;
let _totalMadeShots = 0;
let _totalScore = 0;
let _ballXPosition = 0;
let _ballVelocity = 0;
let _madeInARowCount = 0;
let _onFire = false;
let _setOnFireTimeout = 0;
let _mainAssetsLoaded = false;
let _instructionsViewed = false;


/**
 * Finds the correct level data object
 * @param {Number} level - The current game level
 * @returns {Object} a level data object
 */
function findcurrentLevelData(level) {
  let currentLevelData;

  for (let i = 0; i < data.levelData.length; i++) {
    if (data.levelData[i].level === level) {
      currentLevelData = data.levelData[i];
      break;
    }
  }

  return currentLevelData;
}

let _currentLevelData = findcurrentLevelData(1);

const GameStore = Object.assign({}, events.EventEmitter.prototype, {
  /**
   * Adds a basket to the list of baskets
   * @param {Object} sprite - a PIXI.js sprite
   * @returns {undefined} undefined
   */
  addBasket(sprite) {
    _baskets.push(sprite);
    _totalBaskets++;
  },


  /**
   * Removes a basket from the list of baskets
   * @param {String} sprite - The basket sprite to remove
   * @returns {undefined} undefined
   */
  removeBasket(sprite) {
    for (let i = 0; i < _baskets.length; i++) {
      if (_baskets[i]._gameId === sprite._gameId) {
        _baskets.splice(i, 1);
      }
    }
  },


  /**
   * Adds a basket to the list of baskets
   * @param {Object} sprite - a PIXI.js sprite
   * @returns {undefined} undefined
   */
  addBall(sprite) {
    _balls.push(sprite);

    if (!_levelStats['level' + _currentLevelData.level]) {
      _levelStats['level' + _currentLevelData.level] = {
        madeShots: 0,
        percentageMade: 0,
        totalShots: 0,
        score: 0,
      };
    }

    _levelStats['level' + _currentLevelData.level].totalShots++;
    _totalShots++;
  },


  /**
   * Removes a ball from the list of balls
   * @param {String} sprite - The ball sprite to remove
   * @returns {undefined} undefined
   */
  removeBall(sprite) {
    for (let i = 0; i < _balls.length; i++) {
      if (_balls[i]._gameId === sprite._gameId) {
        _balls.splice(i, 1);
      }
    }
  },


  /**
   * Returns the current breakpoint
   * @returns {String} the current breakpoint
   */
  getState() {
    return {
      shootingBall: _shootingBall,
      ballXPosition: _ballXPosition,
      ballVelocity: _ballVelocity,
      basketToRemove: _basketToRemove,
      ballToRemove: _ballToRemove,
      totalShots: _totalShots,
      totalMadeShots: _totalMadeShots,
      totalScore: _totalScore,
      levelStats: _levelStats,
      totalBaskets: _totalBaskets,
      currentLevelData: _currentLevelData,
      paused: _paused,
      onFire: _onFire,
      mainAssetsLoaded: _mainAssetsLoaded,
      instructionsViewed: _instructionsViewed,
    };
  },


  /**
   * Emits change event
   * @returns {undefined} undefined
   */
  emitChange() {
    this.emit(CHANGE_EVENT);
  },


  /**
   * Ads a listener function to the store
   * @param {Function} callback A function to add as a callback
   * @returns {undefined} undefined
   */
  addChangeListener(callback) {
    this.on(CHANGE_EVENT, callback);
  },


  /**
   * Removes a listener function from the store
   * @param {Function} callback A function to remove from the callbacks
   * @returns {undefined} undefined
   */
  removeChangeListener(callback) {
    this.removeListener(CHANGE_EVENT, callback);
  },


  /**
   * Listens for events and takes action accordingly
   * @returns {Boolean} true
   */
  dispatcherIndex: AppDispatcher.register((payload) => {
    const action = payload.action;

    switch (action.actionType) {

      case AppConstants.SHOOT_BALL:
        _shootingBall = true;
        _ballXPosition = action.ballXPosition;
        _ballVelocity = action.ballVelocity;

        GameStore.emitChange();

        _shootingBall = false;

        break;

      case AppConstants.SET_LEVEL:
        _currentLevelData = findcurrentLevelData(action.level);

        GameStore.emitChange();

        break;

      case AppConstants.RESET:
        _shootingBall = false;
        _balls = [];
        _baskets = [];
        _totalBaskets = 0;
        _totalShots = 0;
        _totalMadeShots = 0;
        _totalScore = 0;
        _ballXPosition = 0;
        _levelStats = {};
        _currentLevelData = findcurrentLevelData(1);

        GameStore.emitChange();

        break;

      case AppConstants.PAUSE:
        _paused = true;

        GameStore.emitChange();

        break;

      case AppConstants.UN_PAUSE:
        _paused = false;

        GameStore.emitChange();

        break;

      case AppConstants.MAIN_ASSETS_LOADED:
        _mainAssetsLoaded = true;

        GameStore.emitChange();

        break;

      case AppConstants.INSTRUCTIONS_VIEWED:
        _instructionsViewed = true;

        GameStore.emitChange();

        break;

      default:
        break;
    }

    return true;
  }),
});

function checkForCollisions() {
  const currentLevelData = _levelStats['level' + _currentLevelData.level];

  for (let h = 0; h < _baskets.length; h++) {
    for (let b = 0; b < _balls.length; b++) {
      if ((_balls[b].x + _balls[b].width >= _baskets[h].x) &&
        (_balls[b].x <= _baskets[h].x + _baskets[h].width) &&
        (_balls[b].y + _balls[b].height >= _baskets[h].y) &&
        (_balls[b].y <= _baskets[h].y + _baskets[h].height) &&
        !_baskets[h].willBeRemoved) {
        _basketToRemove = _baskets[h];
        _ballToRemove = _balls[b];

        _totalMadeShots++;
        _madeInARowCount++;

        currentLevelData.madeShots++;

        if (_baskets[h]._isSpecial) {
          currentLevelData.score += 3;
          _totalScore += 3;
        } else {
          currentLevelData.score++;
          _totalScore ++;
        }

        currentLevelData.percentageMade =
          currentLevelData.madeShots /
          currentLevelData.totalShots;

        GameStore.emitChange();

        if (_madeInARowCount > 5 &&
          !_onFire &&
          !_setOnFireTimeout) {
          _setOnFireTimeout = setTimeout(() => {
            _onFire = true;
            _setOnFireTimeout = 0;
          }, 10);
        }

        _basketToRemove = null;
        _ballToRemove = null;
        break;
      }
    }

    for (let b = 0; b < _balls.length; b++) {
      if (_balls[b].y < 0 && !_balls[b]._missed) {
        _balls[b]._missed = true;
        _madeInARowCount = 0;
        _setOnFireTimeout = setTimeout(() => {
          _onFire = false;
          _setOnFireTimeout = 0;
        }, 10);
        break;
      }
    }
  }

  window.requestAnimationFrame(checkForCollisions);
}

window.requestAnimationFrame(checkForCollisions);

module.exports = GameStore;



/** WEBPACK FOOTER **
 ** ./assets/js/src/stores/GameStore.js
 **/